// sortPostsByType.js (PURE) - accepts Post[] OR Share[] OR mixed
export function sortPostsByType(items = []) {
  const makeCol = (name) => ({ name, tasks: [] });

  const cols = {
    drafts: makeCol("Drafts"),
    in_progress: makeCol("In Progress"),
    ready: makeCol("Ready"),
    planned: makeCol("Planned"),
    published: makeCol("Published"),
  };

  const normalize = (item) => {
    if (!item) return null;

    // Share shape: { id, post: { id, status?, draft?, schedules? }, ... }
    const post = item.post ?? item;

    if (!post?.id) return null;

    // task id: prefer share.id when present (so DnD keys are unique per share),
    // otherwise fall back to post.id
    const taskId = item.post ? String(item.id ?? post.id) : String(post.id);

    // derive a status when backend uses draft flag or schedules
    // priority: explicit post.status
    let status = post.status;

    // fallback heuristics if status missing
    if (!status) {
      if (post.draft === true) status = "draft";
      else if (Array.isArray(post.schedules) && post.schedules.length > 0) status = "scheduled";
      else status = "draft";
    }

    return {
      id: taskId,
      post: { ...post, status }, // ensure status exists
      raw: item,                 // preserve original (Post or Share)
      isShare: !!item.post,
    };
  };

  for (const item of items ?? []) {
    const task = normalize(item);
    if (!task) continue;

    switch (task.post.status) {
      case "draft":
        cols.drafts.tasks.push(task);
        break;
      case "in_progress":
        cols.in_progress.tasks.push(task);
        break;
      case "ready":
        cols.ready.tasks.push(task);
        break;
      case "scheduled": // your "planned" column
      case "planned":
        cols.planned.tasks.push(task);
        break;
      case "published":
        cols.published.tasks.push(task);
        break;
      default:
        cols.drafts.tasks.push(task);
        break;
    }
  }

  return cols;
}
